import './branding.scss';

function Branding() {
    return (
        <div className="branding">Michael Stevens</div>
    );
}

export default Branding;